import { makeStyles } from '@material-ui/core/styles'

export const taskStyles = makeStyles((theme) => ({
    gameOverBtnContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        right: '20px',
        position: 'fixed'
    },
    gameOverBtn: {
        borderColor: 'red',
        backgroundColor: 'red',
        padding: 5,
        color: 'white',
        '&:hover': {
            borderColor: 'red',
            backgroundColor: 'red',
        }
    },
    answersWrapper: {
        display: 'flex',
        flexDirection: 'row'
    },
    containerTimer: {
        padding: 15,
        margin: '1.5em 0',

    },
    timerSpan: {
        padding: 10,
        margin: '0 10px',
        borderRadius: 5
    },
    timeText: {
        color: 'white',
        fontSize: '1.5rem',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.9rem',
        },
    }
}))
